import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { createResourceExplorerFolderThunkFixedCacheKey } from "../../thunks/resource-explorer-hierarchy/createResourceExplorerHierarchyFolderThunk";

export const createResourceExplorerFolderSelector =
  cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentResourceExplorerFolders.select(
    createResourceExplorerFolderThunkFixedCacheKey,
  );
